import React from 'react';
import './RankTable.css';

const GPU_COLORS = {
  BLUE: '#007AFF',
  PINK: '#fe11c5',
  PURPLE: '#AF52DE',
  ORANGE: '#FF9500',
  GREEN: '#34C759'
};

function getGlowColor(gpuColor) {
  const color = GPU_COLORS[gpuColor.toUpperCase()] || GPU_COLORS.BLUE;
  return color;
}

function getTimeAgo(dateString) {
  const now = new Date();
  const updated = new Date(dateString);
  const diffMs = now - updated;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffDay > 0) return `${diffDay} day${diffDay > 1 ? 's' : ''} ago`;
  if (diffHour > 0) return `${diffHour} hour${diffHour > 1 ? 's' : ''} ago`;
  if (diffMin > 0) return `${diffMin} minute${diffMin > 1 ? 's' : ''} ago`;
  return 'just now';
}

function formatDateTime(dateString) {
  const d = new Date(dateString);
  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const year = d.getUTCFullYear();
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} | ${hours}:${minutes} UTC`;
}

function RankTable({ data }) {
  const glowColor = getGlowColor(data.gpu_color);
  
  return (
    <div className="rank-table-container" style={{ '--glow-color': glowColor }}>
      <table className="rank-table">
        <tbody>
          <tr>
            <th>Rank</th>
            <td>{data.rank}</td>
          </tr>
          <tr>
            <th>Prover</th>
            <td>{data.prover}</td>
          </tr>
          <tr>
            <th>Proofs</th>
            <td>{data.proofs}</td>
          </tr>
          <tr>
            <th>Points</th>
            <td>{data.points}</td>
          </tr>
          <tr>
            <th>Stars</th>
            <td>{data.stars}</td>
          </tr>
          <tr>
            <th>GPU Color</th>
            <td>{data.gpu_color}</td>
          </tr>
          <tr>
            <th>Database last updated at (UTC)</th>
            <td>{getTimeAgo(data.updated_at)} ({formatDateTime(data.updated_at)})</td>
          </tr>
        </tbody>
      </table>

      <div className="stats-container">
        <div className="stat-card" style={{ 
          border: `1px solid ${glowColor}30`,
          boxShadow: `0 0 10px ${glowColor}20, 0 0 20px ${glowColor}10`
        }}>
          <div className="stat-title">Top Percentile</div>
          <div className="stat-value" style={{ color: glowColor }}>{data.top_percent}%</div>
          <div className="stat-progress">
            <div 
              className="stat-progress-bar" 
              style={{ 
                width: `${data.top_percent}%`,
                background: `linear-gradient(90deg, ${glowColor}, ${glowColor}80)`
              }}
            />
          </div>
        </div>
        
        <div className="stat-card" style={{ 
          border: `1px solid ${glowColor}30`,
          boxShadow: `0 0 10px ${glowColor}20, 0 0 20px ${glowColor}10`
        }}>
          <div className="stat-title">Total Participants</div>
          <div className="stat-value" style={{ color: glowColor }}>{data.total_count.toLocaleString()}</div>
          <div className="stat-description">Active provers in the network</div>
        </div>
      </div>
    </div>
  );
}

export default RankTable; 